import { bsc, bscTestnet, mainnet, polygon, polygonMumbai } from 'wagmi/chains'

export type ContractAddressMap = Record<number, `0x${string}`>

export const FACTORY_ADDRESS: ContractAddressMap = {
  [polygonMumbai.id]: '0x861E3c82Bc2753ea64aE5f962d993DF6853a6700',
  [bscTestnet.id]: '0x861E3c82Bc2753ea64aE5f962d993DF6853a6700',
  [mainnet.id]: '0x861E3c82Bc2753ea64aE5f962d993DF6853a6700',
  [bsc.id]: '0x861E3c82Bc2753ea64aE5f962d993DF6853a6700',
  [polygon.id]: '0x6f474cF5B1e348E361D81617A4f977607a4931a9',
}

export const VAULT_ADDRESS: ContractAddressMap = {
  [polygonMumbai.id]: '0x40a3a97ac5d9acadF9F96cB8283a912dDFd05dc8',
  [bscTestnet.id]: '0x1A5A52E71dA7f49644CcEE97b793e1CA7461701a',
  [mainnet.id]: '0xaEA5fA28cf2b56DEa9d1dea2AC8E76E799143A28',
  [bsc.id]: '0xaEA5fA28cf2b56DEa9d1dea2AC8E76E799143A28',
  [polygon.id]: '0xaEA5fA28cf2b56DEa9d1dea2AC8E76E799143A28',
}

export const FARM_ADDRESS: ContractAddressMap = {
  [polygonMumbai.id]: '0xc3D0e05491C500F69aa440672a1E9CA6C2537479',
  [bscTestnet.id]: '0x99672E31174CFA14741d1a4EfFB26DF4Ba62b72F', // fake
  [mainnet.id]: '0x2EDfFbc62C3dfFD2a8FbAE3cd83A986B5bbB5495',
  [bsc.id]: '0x99672E31174CFA14741d1a4EfFB26DF4Ba62b72F', // fake
  [polygon.id]: '0x99672E31174CFA14741d1a4EfFB26DF4Ba62b72F', // fake
}

export const CHAIN_SUPPORT_FARM_ADDRESS: number[] = [polygonMumbai.id, mainnet.id]
export const PROJECT_SITE = ['https://www.nxhub.io/', 'https://bitstable.finance/']
